import { Suspense } from 'react'
import dynamic from 'next/dynamic'

import { useAppSelector } from '@/src/store/hooks'
import { selectPiPCurrentTab, TPiPTab } from '@/src/store/slices/pip'

const Home = dynamic(async () => await import('@/src/components/pip/pages/Home/Home'), {
  ssr: false,
  loading: () => null,
})
const Participants = dynamic(
  async () => await import('@/src/components/pip/pages/Participants/Participants'),
  { ssr: false, loading: () => null },
)
const Chat = dynamic(async () => await import('@/src/components/pip/pages/Chat/Chat'), {
  ssr: false,
  loading: () => null,
})

interface IScreen {
  value: TPiPTab
  element: JSX.Element
}

const screens: IScreen[] = [
  {
    value: 'home',
    element: (
      <Suspense>
        <Home />
      </Suspense>
    ),
  },
  {
    value: 'participants',
    element: (
      <Suspense>
        <Participants />
      </Suspense>
    ),
  },
  {
    value: 'chat',
    element: (
      <Suspense>
        <Chat />
      </Suspense>
    ),
  },
]

export const MainScreen = () => {
  const currentTab = useAppSelector(selectPiPCurrentTab)

  return (
    <section
      className="pip-main-screen-container"
      style={{ borderTopColor: currentTab !== 'home' ? 'rgba(255, 255, 255, 0.1)' : 'transparent' }}
    >
      {screens.find(({ value }) => value === currentTab)?.element || null}
    </section>
  )
}
